import { SHIPPING_LIST_TYPES } from '@common/Checkout/Checkout/constants';
import { ShippingState } from '@common/Checkout/Checkout/types';
import { ShippingReducer } from '@common/Checkout/Checkout/types/reducers';
import { RECEIVE_SHIPPING_LIST_DATA, RESET_SHIPPING_LIST_DATA } from '../actions/constants';

const initialState: ShippingState = {
    [SHIPPING_LIST_TYPES.regular]: {
        selectedShippingId: 0,
        shippings: [],
        collapsable: false,
        isCollapsed: false,
        collapseLimit: null,
        isLoaded: false,
    },
    [SHIPPING_LIST_TYPES.pallet]: {
        selectedShippingId: 0,
        shippings: [],
        collapsable: false,
        isCollapsed: false,
        collapseLimit: null,
        isLoaded: false,
    },
};

// eslint-disable-next-line @typescript-eslint/default-param-last
const reducer: ShippingReducer = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case RECEIVE_SHIPPING_LIST_DATA: {
            const { listType, shippingListData } = payload;
            return { ...state, [listType]: { ...shippingListData, isLoaded: true } };
        }

        case RESET_SHIPPING_LIST_DATA: {
            const { listType } = payload;

            if (listType) {
                return { ...state, [listType]: initialState[listType] };
            }

            return initialState;
        }

        default:
            return state;
    }
};

export default reducer;
